import AbasService from "./AbasService";
import AnaliseProdValidacao from "../validation/AnaliseProdValidacao";

export default {
  mixins: [AbasService, AnaliseProdValidacao],
  data() {
    return {
      comboAnalistas: [],
      analistasSelecionados: [],
      dataInicial: "",
      dataFinal: ""
    };
  },
  beforeMount() {
    this.inicializarAnalistas();
  },
  methods: {
    download() {
      const result = this.checkForErrors();

      if (result.error) {
        this.$store.commit("setErro", {
          mostrarErro: true,
          titulo: "Erro de Validação",
          codigoErro: 422,
          mensagemErro: result.message
        });
        return;
      }

      const payload = {
        dataInicio: this.formatarDataParaEnvio(this.dataInicial),
        dataFim: this.formatarDataParaEnvio(this.dataFinal),
        analistas: this.formatarAnalistasParaEnvio()
      };

      this.$emit("download", payload);
    },
    inicializarAnalistas() {
      return this.getComboAnalistas().then(({ data }) => {
        if (data) {
          this.comboAnalistas = data;
        }
      });
    },
    formatarDataParaEnvio(string) {
      return string
        .split("/")
        .reverse()
        .join("-");
    },
    formatarAnalistasParaEnvio() {
      let arrIdAnalista = [];
      this.analistasSelecionados.forEach(analista =>
        arrIdAnalista.push(analista.id)
      );
      return arrIdAnalista.join(",");
    }
  }
};
